<template>
    <div id="clientHedgingReport">
        <CRow>
            <CCol>
                <div class="e-card mt-2">

                    <div id="clientHedgingSpinner"></div>

                    <div class="form-row col-lg-12">
                        <div class="col-sm-2">
                            <div class="col-sm-12 m-2">
                                <ejs-dropdownlist id="dplReportingView" name="dplReportingView" ref="reportingView" :dataSource='reportingView' :fields="{text: 'name', value: 'id' }" :select='onReportViewSelect' placeholder="Reporting View" floatLabelType='Auto'></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="col-sm-4  justify-content-end ">
                            <label style="color: #f78764;">Data shown is from yesterday EOD, you can generate latest with hitting refresh data button</label>
                        </div>
                        <div class="col-sm-2">
                            <label id="lbltimeUpdated" name="lbltimeUpdated" ref="lbltimeUpdated">Time Updated:{{timeUpdated}}</label>
                        </div>
                        <div class="col-sm-2  justify-content-end ">
                            <ejs-button cssClass="e-primary" v-on:click.native='refreshData'>Refresh Data</ejs-button>
                        </div>
                        <div class="col-sm-2 justify-content-end">
                            <ejs-button cssClass="e-primary" ref="btnHedgingOverview" v-on:click.native='download'>Hedging Overview Report</ejs-button>
                            <ejs-checkbox cssClass="postionCheck check-d" ref='dmCheck' :checked="isChecked"
                               @change="updateChecked" label='Default Mechanism' id="clientHedging" name="checkName" floatLabelType='Auto'></ejs-checkbox>
                        </div>
                    </div>
                    <div v-show="PowerEnabled">
                        <div class="row">
                            <div class="col m-3">
                                <div class="e-control e-grid e-responsive e-default" style="background-color: #d9843b; color: #001c55;">
                                    <CIcon name="cil-bolt" style="color: #001c55;"/> Power
                                </div>
                            </div>
                        </div>
                            <div class="col-lg-12 mt-3">
                                <ejs-grid ref="gridPowerYear" :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true'
                                  :autoFitAll='true' width="100%"
                                          :dataSource="powerYearData" id="gridPowerYear"
                                          :dataBound="dataBoundYearlyPower" :queryCellInfo='customiseCellPow'></ejs-grid>
                            </div>
                        <div class="col-lg-12 mt-3">
                            <ejs-grid ref="gridPowerQuarter" :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true'
                                      :autoFitAll='true' width="100%"
                                      :dataSource="powerQuarterData" id="gridPowerQuarter"
                                      :dataBound="dataBoundQuarterlyPower"
                                      :queryCellInfo='customiseCell'></ejs-grid>
                        </div>
                        <div class="col-lg-12 mt-3 mb-3">
                            <ejs-grid ref="gridPowerMonth" :allowTextWrap='true' :textWrapSettings='wrapSettings':allowResizing='true'
                                      :autoFitAll='true' width="100%"
                                      :dataSource="powerMonthData" id="gridPowerMonth"
                                      :dataBound="dataBoundMonthlyPower"
                                      :queryCellInfo='customiseCell'></ejs-grid>


                        </div>
                    </div>
                    <div v-show="GasEnabled">
                        <div class="row">
                            <div class="col m-3">
                                <div class="e-control e-grid e-responsive e-default" style="background-color: #7FB7BE; color: #001c55;">
                                    <CIcon name="cil-bolt" style="color: #001c55;"/> Gas
                                </div>
                            </div>
                        </div>
                            <div class="col-lg-12 mt-3">
                                <ejs-grid ref="gridGasYear" :allowTextWrap='true' :textWrapSettings='wrapSettings':allowResizing='true'
                                      :autoFitAll='true' width="100%"
                                          :dataSource="gasYearData" id="gridGasYear"
                                          :dataBound="dataBoundYearlyGas" :queryCellInfo='customiseCellGas'></ejs-grid>
                            </div>
                       
                        <div class="col-lg-12 mt-3">
                            <ejs-grid ref="gridGasQuarter" :allowTextWrap='true' :textWrapSettings='wrapSettings':allowResizing='true'
                                      :autoFitAll='true' width="100%"
                                      :dataSource="gasQuarterData" id="gridGasQuarter"
                                      :dataBound="dataBoundQuarterlyGas"
                                      :queryCellInfo='customiseCell'></ejs-grid>
                        </div>
                        <div class="col-lg-12 mt-3 mb-3">
                            <ejs-grid ref="gridGasMonth" :allowTextWrap='true' :textWrapSettings='wrapSettings':allowResizing='true'
                                      :autoFitAll='true' width="100%"
                                      :dataSource="gasMonthData" id="gridGasMonth"
                                      :dataBound="dataBoundMonthlyGas"
                                      :queryCellInfo='customiseCell'></ejs-grid>
                        </div>
                    </div>
                </div>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { DropDownListPlugin, MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, CheckBox, ButtonPlugin, RadioButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { NumericTextBoxPlugin, UploaderPlugin, TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';

    import { GridPlugin, Grid, Edit, Page, Toolbar, Sort, Filter, Reorder, ColumnMenu,Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import apis from '../../common/network'
    import urls from '../../common/urls';
    import store from '../../store';
    import gridOptions from '../../common/gridOptions'
    import {
        ProgressBarPlugin,
    } from "@syncfusion/ej2-vue-progressbar";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    import ProgressBarTemplate from '@/views/helperTemplates/ProgressBar.vue';

    Vue.use(ProgressBarPlugin);
    Vue.use(RadioButtonPlugin);
    Vue.use(DialogPlugin);
    Vue.use(DatePickerPlugin);
    Vue.use(NumericTextBoxPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(MultiSelectPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    export default {
        created() {

        },
        mounted() {
            this.$refs.reportingView.ej2Instances.value = 1;
            createSpinner({
                target: document.getElementById('clientHedgingSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            this.isChecked = this.getIsClientDefaultMFromLocalStorage();
            showSpinner(document.getElementById('mainSpinner'));
            this.loadData("CAL");
        },
        data() {
            return {
                wrapSettings: { wrapMode: 'Header' },
                reportingView: [{ "name": "CAL", "id": 1 }, { "name": "FIY", "id": 2 }, { "name": "12M", "id": 3 }],
                powerMonthData: [],
                powerQuarterData: [],
                powerYearData: [],
                gasMonthData: [],
                gasQuarterData: [],
                gasYearData: [],
                PowerEnabled: false,
                GasEnabled: false,
                calendarEnabled: false,
                triggeredYearlyPower: false,
                triggeredMonthlyPower: false,
                triggeredQuarterlyPower: false,
                triggeredMonthlyGas: false,
                triggeredQuarterlyGas: false,
                triggeredYearlyGas: false,
                fisAndCalData: null,
                isChecked: false,
                gasProgressTemplate: function () {
                    return { template: ProgressBarTemplate }
                },                
                powerProgressTemplate: function () {
                    return {
                        template: ProgressBarTemplate,
                    };
                },
                timeUpdated:null
            }
        },
        methods: {
            onReportViewSelect: function (args) {
                let selected = args.itemData.name;
                this.loadData(selected);
            },
            dataBoundMonthlyPower: function () {
                if (this.triggeredMonthlyPower == false) {
                    this.dataBoundMonthly(this.$refs.gridPowerMonth);
                    this.triggeredMonthlyPower = true;
                }
            },
            dataBoundYearlyPower: function () {
                if (this.triggeredYearlyPower == false) {
                    this.dataBoundP(this.$refs.gridPowerYear, this.powerProgressTemplate);
                    this.triggeredYearlyPower = true;
                }
            },
            
            dataBoundQuarterlyPower: function () {
                if (this.triggeredQuarterlyPower == false) {
                    this.dataBoundQuarterly(this.$refs.gridPowerQuarter);
                    this.triggeredQuarterlyPower = true;
                }
            },
            dataBoundMonthlyGas: function () {
                if (this.triggeredMonthlyGas == false) {
                    this.dataBoundMonthly(this.$refs.gridGasMonth);
                    this.triggeredMonthlyGas = true;
                }
            },
            dataBoundYearlyGas: function () {
                if (this.triggeredYearlyGas == false) {
                    this.dataBoundG(this.$refs.gridGasYear, this.gasProgressTemplate);
                    this.triggeredYearlyGas = true;
                }
            },
            
            dataBoundQuarterlyGas: function () {
                if (this.triggeredQuarterlyGas == false) {
                    this.dataBoundQuarterly(this.$refs.gridGasQuarter);
                    this.triggeredQuarterlyGas = true;
                }
            },
            dataBoundP: function (grid, template) {
                var cols = Object.keys(grid.getCurrentViewRecords()[0]);
                var length = cols.length;
                var col = [];
                for (var i = 0; i < length; i++) {
                    var field = cols[i];
                    var obj = {};
                    obj["field"] = field;
                    if (field != "State") {
                        obj["template"] = (props) => template(props);
                    }
                    col.push(obj);
                }
                grid.setProperties({ columns: col });

                grid.refresh();

            },
            dataBoundG: function (grid, template) {
                var cols = Object.keys(grid.getCurrentViewRecords()[0]);
                var length = cols.length;
                var col = [];
                for (var i = 0; i < length; i++) {
                    var field = cols[i];
                    var obj = {};
                    obj["field"] = field;
                    if (field != "State") {
                        obj["template"] = (props) => template(props);
                    }
                    col.push(obj);
                }
                grid.setProperties({ columns: col });

                grid.refresh();

            },
            dataBound: function (grid, template) {
                var cols = Object.keys(grid.getCurrentViewRecords()[0]);
                var length = cols.length;
                var col = [];
                for (var i = 0; i < length; i++) {
                    var field = cols[i];
                    var obj = {};
                    obj["field"] = field;
                    if (field != "State") {
                        obj["template"] = template;
                    }
                    else {
                        //set state width
                        //obj["width"] = 120;
                    }
                    col.push(obj);
                }
                grid.setProperties({ columns: col });
                
                grid.refresh();

            },
            dataBoundMonthly: function (grid) {
                var cols = Object.keys(grid.getCurrentViewRecords()[0]);
                var length = cols.length;
                var col = [];
                for (var i = 0; i < length; i++) {
                    var field = cols[i];
                    var obj = {};
                    obj["field"] = field;
                    if (field == "State") {
                         //obj["width"] = 120;
                    } else {
                        obj["width"] = 80;}
                    col.push(obj);
                }
                grid.setProperties({ columns: col });
                grid.autoFitColumns(['State']);

            },
            dataBoundQuarterly: function (grid) {
                var cols = Object.keys(grid.getCurrentViewRecords()[0]);
                var length = cols.length;
                var col = [];
                for (var i = 0; i < length; i++) {
                    var field = cols[i];
                    var obj = {};
                    obj["field"] = field;
                    if (field == "State") {
                         // obj["width"] = 120;
                    } else {
                        obj["width"] = 240;}
                    col.push(obj);
                }
                grid.setProperties({ columns: col });
                grid.autoFitColumns(['State']);

            },
            customiseCell: function (args) {
                if (args.column.field != 'State') {
                    if (args.data[args.column.field] > 75) {
                        args.cell.classList.add('percentage75');
                    } else if (args.data[args.column.field] > 50) {
                        args.cell.classList.add('percentage50');
                    }
                    else if (args.data[args.column.field] > 25) {
                        args.cell.classList.add('percentage25');
                    }
                    else if (args.data[args.column.field] > 0.5 && args.data[args.column.field] < 25) {
                        args.cell.classList.add('percentage05');
                    }
                    else {
                        args.cell.classList.add('percentage0');
                    }

                    
                    args.cell.textContent = args.cell.textContent + '%';
                 }
            },
            customiseCellPow: function (args) {
                if (args.cell.textContent == "NaN%") {
                    args.cell.textContent = '%';
                }
             
            },
            customiseCellGas: function (args) {
                if (args.cell.textContent == "NaN%") {
                    args.cell.textContent = '%';
                }

            },
            updateChecked(event) {
                // Update values in Local Storage
                this.setIsClientDefaultMInLocalStorage(event.checked);
                // Update values in Vuex store
                this.$store.commit('setClientCheckDefaultM', event.checked);
                let selected = document.getElementById('dplReportingView').value;
                this.loadData(selected);
            },
            getIsClientDefaultMFromLocalStorage() {
                const storedValue = localStorage.getItem('defaultMech');
                return storedValue ? JSON.parse(storedValue) : false;
            },
            setIsClientDefaultMInLocalStorage(value) {
                localStorage.setItem('defaultMech', JSON.stringify(value));
            },
            download: function (args) {
                showSpinner(document.getElementById('clientHedgingSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generateClientHedgingReportPage/${store.state.reportClientId}
                                                     ?defaultM=${store.state.isClientDefaultM == true ? true : false}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('clientHedgingSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                        hideSpinner(document.getElementById('clientHedgingSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                    }
                );
            }, 
            refreshData: function (args) {
                apis.protectedApi(`${urls.apiBaseUrl}Report/refreshClientData/${store.state.reportClientId}?defaultM=${store.state.isClientDefaultM == true ? true : false}`);
                gridOptions.infoAlert("Refresh data triggered, the data is being processed now. The time will be refreshed in the next 2 min.Please refresh to get latest data");

            },
            loadData: function (type) {
                if ( this.fisAndCalData == null) {
                     showSpinner(document.getElementById('mainSpinner'));
                     showSpinner(document.getElementById('clientHedgingSpinner'));
                     apis.protectedApi(`Report/ClientHedging/${store.state.reportClientId}?defaultM=${store.state.isClientDefaultM == true ? true : false}`).then(it => {

                        this.fisAndCalData = it;
                        this.PowerEnabled = it.data.hasPower;
                        this.GasEnabled = it.data.hasGas;
                        var d = new Date(it.data.timeUpdated + "Z");
                        var datestring = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() + " " +
                            d.getHours() + ":" + d.getMinutes();
                        this.timeUpdated = datestring;
                        this.populateData(it, type);
                         hideSpinner(document.getElementById('clientHedgingSpinner'));
                         hideSpinner(document.getElementById('mainSpinner'));
                    }).catch(
                        response => {
                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                            gridOptions.errorAlert("Error: " + message);
                            hideSpinner(document.getElementById('clientHedgingSpinner'));
                            hideSpinner(document.getElementById('mainSpinner'));
                        }
                    );
                }
                else {
                    this.populateData(this.fisAndCalData, type);
                   
                }
            },
            populateData: function (it, inputType) {
                var type = "calendar";

                if (inputType == "CAL") {
                    type = "calendar"
                } else if (inputType == "FIY") {
                    type = "fiscal";
                }
                    else {
                    type = "rollingMonths";
                }
                if (it.data[type] && (it.data[type].power.monthly.length > 0 || it.data[type].power.yearly.length > 0 || it.data[type].power.quarterly.length > 0
                    || it.data[type].gas.monthly.length > 0 || it.data[type].gas.yearly.length > 0 || it.data[type].gas.quarterly.length > 0)) {

                    if (it.data[type].power.monthly.length > 0) {
                        this.triggeredMonthlyPower = false;
                        this.powerMonthData = it.data[type].power.monthly;
                    }
                    if (it.data[type].power.yearly.length > 0) {
                        this.triggeredYearlyPower = false;
                        this.powerYearData = it.data[type].power.yearly;
                    }
                    if (it.data[type].power.quarterly.length > 0) {
                        this.triggeredQuarterlyPower = false;
                        this.powerQuarterData = it.data[type].power.quarterly;
                    }

                    if (it.data[type].gas.monthly.length > 0) {
                        this.triggeredMonthlyGas = false;
                        this.gasMonthData = it.data[type].gas.monthly;
                    }
                    if (it.data[type].gas.yearly.length > 0) {
                        this.triggeredYearlyGas = false;
                        this.gasYearData = it.data[type].gas.yearly;
                    }

                    if (it.data[type].gas.quarterly.length > 0) {
                        this.triggeredQuarterlyGas = false;
                        this.gasQuarterData = it.data[type].gas.quarterly;
                    }

                    this.$refs.btnHedgingOverview.ej2Instances.disabled = false;
                } else {
                    this.$refs.btnHedgingOverview.ej2Instances.disabled = true;
                }

            }
        },
        watch: {
            '$store.state.isClientDefaultM'(newVal) {
                //Sync the local state with the store, ensuring real-time updates on value changes.
                this.isChecked = newVal;
            }
        },
        computed: {

        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, ColumnMenu, Resize, Reorder, ExcelExport, ForeignKey]
        }
    }
</script>

<style>

    .percentage75 {
        background-color: #001c55 !important;
        color: #Dae0f2 !important;
    }
    .percentage50 {
        background-color: #485696 !important;
        color: #Dae0f2 !important;
    }
    .percentage25 {
        background-color: #7d84b2 !important;
    }
    .percentage05 {
        background-color: #Dae0f2 !important;
    }
    .percentage0 {
        background-color: white !important;
    }
    #clientHedgingSpinner {
        display: none;
    }
</style>